export default "__VITE_ASSET__BzOkZUca__"